export const searchValues = {
  toDate: "",
  fromDate: "",
  searchKey: "",
  hasIbanCopied: "",
  isMessageSent: "",
  hasLinkClicked: "",
  hasOrderCompleted: "",
};

export const excelHeaderCellsName = {
  " الهاتف": "phoneNumber",
  "تاريخ الإرسال ": "smsSentAt",
  " اسم مجموعة الرسائل المؤتمتة": "campaignKey",
  "تم إرسال الرسالة": "isSmsSent",
  "تم زيارة الرابط": "hasLinkVisited",
  "تاريخ زيارة الرابط": "linkVisitedAt",
  "تم إكمال الطلب": "hasOrderCompleted",
  "تاريخ إكمال الطلب": "orderCompletedAt",
  "تم نسخ رقم الآيبان": "hasIbanCopied",
  "تاريخ نسخ رقم الآيبان": "ibanCopiedAt",
};
